import { render, staticRenderFns } from "./SupportPanel.vue?vue&type=template&id=7c234bd9&"
import script from "./SupportPanel.vue?vue&type=script&lang=js&"
export * from "./SupportPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports